import React from 'react';
import PropTypes from 'prop-types';
import { Chart, Bar } from 'react-chartjs-2';
import 'chartjs-plugin-datalabels';

class DictationPerformance extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      mode: "day",
      data: {}
    };

    // this.convertHexToRGBA = this.convertHexToRGBA.bind(this);
    this.fetchData = this.fetchData.bind(this);
    this.changeMode = this.changeMode.bind(this);
  }

  // convertHexToRGBA = (hexCode, opacity) => {
  //   let hex = hexCode.replace('#', '');

  //   if (hex.length === 3) {
  //       hex = `${hex[0]}${hex[0]}${hex[1]}${hex[1]}${hex[2]}${hex[2]}`;
  //   }

  //   const r = parseInt(hex.substring(0, 2), 16);
  //   const g = parseInt(hex.substring(2, 4), 16);
  //   const b = parseInt(hex.substring(4, 6), 16);

  //   return `rgba(${r},${g},${b},${opacity / 100})`;
  // }

  changeMode(mode) {
    this.setState(
      {
        mode: mode
      }, () => {
        this.fetchData();
      }
    )
  }

  fetchData() {
    fetch(`${this.props.endpoint}?mode=${this.state.mode}`)
      .then(response => response.json())
      .then(data => {
        this.setState(
          {
            options: {
              responsive: true,
              scales: {
                xAxes: [{
                    stacked: this.state.mode == "day" ? true : false
                }]
              }
            },
            data: {
              datasets: [
                {
                  label: 'Nombre de mots corrects',
                  data: data.correct_words,
                  backgroundColor: '#069162',
                  type: 'bar',
                  order: 4,
                  hidden: this.state.mode == "day" ? false : true,
                  datalabels: {
                    align: 'end',
                    anchor: 'end',
                    backgroundColor: function(context) {
                      return context.dataset.backgroundColor;
                    },
                    borderRadius: 4,
                    color: 'white',
                    formatter: function(value){
                      return value;
                    },
                    display: 'auto'
                  }
                }, {
                  label: 'Fautes',
                  data: data.errors,
                  backgroundColor: '#D33737',
                  type: 'bar',
                  order: 3,
                  hidden: this.state.mode == "year" ? true : false,
                  datalabels: {
                    align: 'end',
                    anchor: 'end',
                    backgroundColor: function(context) {
                      return context.dataset.backgroundColor;
                    },
                    borderRadius: 4,
                    color: 'white',
                    formatter: function(value){
                      return value;
                    },
                    display: 'auto'
                  }
                }, {
                  label: 'Nombre de dictées',
                  data: data.dictations_count,
                  backgroundColor: '#F05A39',
                  type: 'bar',
                  order: 5,
                  hidden: this.state.mode == "day" ? true : false,
                  datalabels: {
                    align: 'end',
                    anchor: 'end',
                    backgroundColor: function(context) {
                      return context.dataset.backgroundColor;
                    },
                    borderRadius: 4,
                    color: 'white',
                    formatter: function(value){
                      return value;
                    },
                    display: 'auto'
                  }
                }, {
                  label: 'Votre score',
                  data: data.average_score,
                  backgroundColor: 'transparent',
                  pointRadius: 4,
                  pointHoverRadius: 8,
                  borderWidth: 4,
                  borderColor: '#EF992B',
                  pointBorderColor: '#EF992B',
                  pointBackgroundColor: '#EF992B',
                  type: 'line',
                  order: 1,
                  datalabels: {
                    align: 'end',
                    anchor: 'end',
                    backgroundColor: '#EF992B',
                    borderRadius: 4,
                    color: 'white',
                    formatter: function(value){
                      return value + ' %';
                    },
                    display: 'auto'
                  }
                },
                {
                  label: 'Score moyen',
                  data: data.all_users_average_score,
                  backgroundColor: 'transparent',
                  pointRadius: 4,
                  pointHoverRadius: 8,
                  borderWidth: 4,
                  borderColor: '#005cbd',
                  pointBorderColor: '#005cbd',
                  pointBackgroundColor: '#005cbd',
                  type: 'line',
                  order: 2,
                  datalabels: {
                    align: 'end',
                    anchor: 'end',
                    backgroundColor: '#005cbd',
                    borderRadius: 4,
                    color: 'white',
                    formatter: function(value){
                      return value + ' %';
                    },
                    display: 'auto'
                  }
                }
              ],
              labels: data.labels
            }
          }
        )
      })
  }

  componentDidMount() {
    this.fetchData();

    Chart.Legend.prototype.afterFit = function() {
      this.height = this.height + 26;
    };
  }

  render() {
    return (
      <div>
        <div>
          <ul className="mb-4">
            <li className={`inline-block rounded py-2 px-4 font-semibold cursor-pointer mr-2 ${this.state.mode == "day" ? "bg-primary text-white" : "bg-grey-light"}`} onClick={() => this.changeMode("day")}>Jours</li>
            <li className={`inline-block rounded py-2 px-4 font-semibold cursor-pointer mr-2 ${this.state.mode == "week" ? "bg-primary text-white" : "bg-grey-light"}`} onClick={() => this.changeMode("week")}>Semaines</li>
            <li className={`inline-block rounded py-2 px-4 font-semibold cursor-pointer mr-2 ${this.state.mode == "month" ? "bg-primary text-white" : "bg-grey-light"}`} onClick={() => this.changeMode("month")}>Mois</li>
            <li className={`inline-block rounded py-2 px-4 font-semibold cursor-pointer mr-2 ${this.state.mode == "year" ? "bg-primary text-white" : "bg-grey-light"}`} onClick={() => this.changeMode("year")}>Années</li>
          </ul>
        </div>
        <Bar data={this.state.data} options={this.state.options} />
      </div>
    );
  }
}

DictationPerformance.propTypes = {
  user_id: PropTypes.number,
  endpoint: PropTypes.string
};

export default DictationPerformance;
